const mutations = {
  setModels(state, data) {
    state.docenteExamens = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.docenteExamen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.docenteExamens.unshift(model);
  },

  updateModel(state, model) {
    const index = state.docenteExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.docenteExamens.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.docenteExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.docenteExamens.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
